// Role-aware route guard (Step 5d Phase 6). Compose INSIDE ProtectedRoute:
//   <ProtectedRoute><RequireRole role="admin"><BetaConsole/></RequireRole></ProtectedRoute>
//
// The SERVER gate (requireRole on /api/beta/*) is the authority; this is UX only — it keeps a
// non-admin from ever rendering the screen and bounces them to the board. Reusable for the
// menus era. While the session is still initialising we render nothing (ProtectedRoute shows
// the spinner), so we never flash-redirect before roles are known.

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Accepts a single `role` OR an `anyOf` list (the user needs at least one). The SERVER gate
// is the authority; this is UX only.
export default function RequireRole({ role, anyOf, children }: { role?: string; anyOf?: readonly string[]; children: ReactNode }) {
  const { isInitializing, user } = useAuth();
  if (isInitializing) return null;
  const have = user?.roles ?? [];
  const allowed = anyOf ?? (role ? [role] : []);
  if (!allowed.some((r) => have.includes(r))) return <Navigate to="/" replace />;
  return <>{children}</>;
}
